import SEO from "../common/SEO";
import HeaderOne from '../common/header/HeaderOne';
import HeaderTopBar from '../common/header/HeaderTopBar';
import AboutFour from '../elements/about/AboutFour';
import CounterUpFour from '../elements/counterup/CounterUpFour';
import CalltoActionFive from '../elements/calltoaction/CalltoActionFive';
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import Separator from "../elements/separator/Separator";
import FooterOne from '../common/footer/FooterOne';
import Copyright from '../common/footer/Copyright';
import ServiceFour from '../elements/service/ServiceFour';
import ServiceOne from '../elements/service/ServiceOne';
import HomeConsultationSplit from '../elements/split/HomeConsultationSplit';
import HomeCommunity from '../elements/split/HomeCommunity';
import LinkAsset from '../elements/calltoaction/LinkAsset';
import HomeSpeakerSplit from '../elements/split/HomeSpeakerSplit';
import HomeTrainerSplit from '../elements/split/HomeTrainerSplit';
import LinkSislo from '../elements/calltoaction/LinkSislo';
import LinkAudit from '../elements/calltoaction/LinkAudit';
import MainTestimonial from '../elements/testimonial/MainTestimonial';
import HomeCourse from '../elements/split/HomeCourse';
import HomeContent from '../elements/split/HomeContent';
import HomeAffiliate from '../elements/split/HomeAffiliate';
import CommunityPricingHome from '../components/community/CommunityPricingHome';
import LinkPdf from "../elements/calltoaction/LinkPdf";



const Home = () => {
    return (
        <>
            <SEO title="Passionate World University" />
            <main className="page-wrapper">
                <HeaderTopBar />
                <HeaderOne btnStyle="btn-small" HeaderSTyle="header-transparent" />

                {/* Start Slider area  Hero section*/}
                <div
                    className="slider-area slider-style-2 variation-2 height-850 bg_image"
                    style={{
                        backgroundImage: `url(${process.env.PUBLIC_URL}/images/bg/bg.PNG)`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        position: 'relative',
                        overflow: 'hidden',
                        height: '850px',
                    }}
                >
                    {/* Black Overlay */}
                    <div
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(0, 0, 0, 0.6)', // adjust darkness here
                            zIndex: 1,
                        }}
                    ></div>

                    {/* Content Area */}
                    <div
                        className="container"
                        style={{
                            position: 'relative',
                            zIndex: 2, // ensures it's above the overlay
                        }}
                    >
                        <div className="row">
                            <div className="col-lg-8 col-xl-6">
                                <div className="inner text-start">
                                    <h2 className="text-white">
                                        The First & Number #1 Platform in Bangladesh to Audit and Accelerate Your Life, Business & Income
                                    </h2>
                                    {/* <h6 className="tag-title">SOLUTION FOR YOUR BUSINESS</h6> */}
                                    <h4 className="tag-title">
                                        We Are Here To Elevate The Life & Financial Well-Being of The Humanity
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* End Slider area  */}

                {/* Start Elements Call To Action Area  */}
                <div className="rwt-callto-action-area rn-section-gapBottom mt-5">
                    <div className="wrapper">
                        <LinkAudit />
                    </div>
                </div>
                {/* End Elements Area  */}

                {/* Start Elements Call To Action Area  */}
                <div className="rwt-callto-action-area rn-section-gapBottom mt-5">
                    <div className="wrapper">
                        <LinkPdf />
                    </div>
                </div>
                {/* End Elements Area  */}


                {/* Start Three Info Service Area  */}
                <div className="rn-service-area mt-2">
                    <div className="container">
                        <ServiceOne
                            serviceStyle="service__style--1 icon-circle-style with-working-process"
                            textAlign="text-center"
                        />
                    </div>
                </div>
                {/* End Service Area  */}

                <AboutFour image="./images/about/contact-image.jpg" />


                <Separator />


                {/* Start Service Area  */}
                <div className="rn-service-area rn-section-gap">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle="Transform Your Life, Business & Income"
                                    title="Empowering Growth Through Training, Consulting & Strategic Partnerships"
                                    description="We help you unlock your full potential with expert-led training programs, one-on-one consulting, inspiring talks, result-driven courses, powerful content, and affiliate opportunities. Our mission is to elevate every area of your life, business, and income."
                                />
                            </div>
                        </div>
                        <ServiceFour
                            serviceStyle="service__style--1 icon-circle-style with-working-process"
                            textAlign="text-center"
                        />
                    </div>
                </div>
                {/* End Service Area  */}


                {/* Start Elements Area  consultation Pricing*/}
                {/* <div className="rwt-advance-tab-area rn-section-gap">
                    <div className="container">
                        <div className="row mb--40">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign = "text-center"
                                    radiusRounded = ""
                                    subtitle = "Value for consulting"
                                    title = "Consulting fees reflect the value of expertise"
                                    description = ""
                                />
                            </div>
                        </div>
                        <ConsultationPricing/>
                    </div>
                </div> */}


                {/* Start Elements Area  Trainer Information*/}
                <div className="rwt-advance-tab-area rn-section-gap">
                    <div className="container">
                        <div className="row mb--40">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle="Our Training Program"
                                    title="Join Jahid Hasan’s High-Impact Training Program and Transform Your Life, Business & Income"
                                    description=""
                                />
                            </div>
                        </div>
                        <HomeTrainerSplit />
                    </div>
                </div>
                {/* End Elements Area  */}

                <Separator />

                {/* Start Elements Area  consultation Information*/}
                <div className="rwt-advance-tab-area rn-section-gap">
                    <div className="container">
                        <div className="row mb--40">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle="Consulting Services"
                                    title="What We Provide Through Our Consulting at PWU?"
                                    description="At Passionate World University, our consulting services are designed to help you structure, systemize, and scale your life, business, and income. From personalized strategy to hands-on support, we guide you to real, measurable growth."
                                />
                            </div>
                        </div>
                        <HomeConsultationSplit />
                    </div>
                </div>
                {/* End Elements Area  */}
                <Separator />

                {/* Start Elements Area  Speaker Information*/}
                <div className="rwt-advance-tab-area rn-section-gap">
                    <div className="container">
                        <div className="row mb--40">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle="Book A Speaker"
                                    title="Book Jahid Hasan — A Speaker Who Sparks Action"
                                    description="No two stages are the same. No two stories inspire the same way.</br>
Find the perfect voice for your next event — a voice that transforms lives, businesses, and mindsets.</br>Available for: Conferences · Summits · Corporate Events · Business Retreats · Universities · Leadership Talks
"
                                />
                            </div>
                        </div>
                        <HomeSpeakerSplit />
                    </div>
                </div>
                {/* End Elements Area  */}






                <Separator />
                {/* Start Elements Area  Course Information*/}
                <div className="rwt-advance-tab-area rn-section-gap">
                    <div className="container">
                        <div className="row mb--40">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle="Digital Course"
                                    title="Digital Courses to Upgrade Your Life, Business & Income"
                                    description="Explore powerful courses designed to help you grow faster, earn smarter, and live better. From financial mastery, sales mastary and business growth to personal development—get the real-world skills and strategies you never learned in school."
                                />
                            </div>
                        </div>
                        <HomeCourse />
                    </div>
                </div>
                {/* End Elements Area  */}

                <Separator />

                {/* Start Elements Area  Content Information*/}
                <div className="rwt-advance-tab-area rn-section-gap">
                    <div className="container">
                        <div className="row mb--40">
                            <div className="col-lg-10 mx-auto">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle="Digital Content"
                                    title="Unlock Daily Wisdom to Grow Your Life, Business & Income"
                                    description="Unlock premium video content designed for business growth, personal development, and inspiration. Subscribe to access exclusive, high-value videos updated regularly to keep you learning, growing, and ahead of the curve."
                                />
                            </div>
                        </div>
                        <HomeContent />
                    </div>
                </div>
                {/* End Elements Area  */}

                <Separator />

                {/* Start Elements Area  Community Information*/}
                <div className="rwt-advance-tab-area rn-section-gap">
                    <div className="container">
                        <div className="row mb--40">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle="Join Our Community"
                                    title="PWU Community – Built for Players, Not Pretenders"
                                    description="Want real growth? Join a network where you don’t just learn—you earn.</br><strong>
Insider trainings. Expert audits. Investor access. Massive income potential.</strong></br>
We’re talking 2.7 lakh to 1.8 CR BDT in 3–10 years—if you execute.</br>
This is not for spectators. It’s for<strong> builders, closers, and empire-makers.</strong>"
                                />
                            </div>
                        </div>
                        <HomeCommunity />
                    </div>
                </div>
                {/* End Elements Area  */}

                {/* Start Elements Area  Community Pricing*/}
                <div className="rwt-advance-tab-area rn-section-gap">
                    <div className="container">
                        <div className="row mb--40">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle="COMMUNITY PRICING"
                                    // title = "Start Learning and Graw With Our Community"
                                    description=""
                                />
                            </div>
                        </div>
                        <CommunityPricingHome />
                    </div>
                </div>
                {/* End Elements Area  */}

                <Separator />

                {/* Start Elements Area  Affiliate Information*/}
                <div className="rwt-advance-tab-area rn-section-gap">
                    <div className="container">
                        <div className="row mb--40">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle="Affiliate Program"
                                    title="Start Earning With Our Affiliate Program"
                                    description="Become a part of our mission. Turn your network into income. Simple, transparent, and made for creators, influencers, and marketers."
                                />
                            </div>
                        </div>
                        <HomeAffiliate />
                    </div>
                </div>
                {/* End Elements Area  */}


                {/* Start Elements Area  */}
                <div className="rwt-counterup-area rn-section-gapBottom mt_dec--30 pt-5 mt-5">
                    <div className="container">
                        <CounterUpFour column="col-lg-3 col-md-6 col-sm-6 col-12" counterStyle="counter-style-4" textALign="text-center" />
                    </div>
                </div>
                {/* End Elements Area  */}

                <Separator />
                {/* Start Elements Call To Action Area  */}
                <div className="rwt-callto-action-area">
                    <div className="wrapper">
                        <LinkAsset />
                    </div>
                </div>
                {/* End Elements Area  */}

                <Separator />
                {/* Start Elements Call To Action Area  */}
                <div className="rwt-callto-action-area rn-section-gapBottom mt-5">
                    <div className="wrapper">
                        <LinkSislo />
                    </div>
                </div>
                {/* End Elements Area  */}

                <Separator />
                {/* Start Testimonial Area  */}
                <div className="rwt-testimonial-area rn-section-gap">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle="Client Feedback"
                                    title="Our Awesome Client."
                                    description="We Provide The Best Training & Consulting Services to Improve Your Life, Business & Income."
                                />
                            </div>
                        </div>
                        <MainTestimonial />
                    </div>
                </div>
                {/* End Testimonial Area  */}

                {/* Start Elements Area  */}
                <div className="rwt-callto-action-area rn-section-gapBottom">
                    <div className="wrapper">
                        <CalltoActionFive />
                    </div>
                </div>
                {/* End Elements Area  */}

                <FooterOne />
                <Copyright />
            </main>

        </>
    )
}

export default Home
